import { useEffect, useState, useMemo } from "react";
import papi from "@/lib/partnerApi";
import { SectionHead } from "./VdaShared";
import { Loader2 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid, Cell } from "recharts";

export default function VdaReports() {
  const [rows, setRows] = useState(null);
  useEffect(() => { papi.get("/vda/prospects").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);

  const { byCat, byCity, byStatus } = useMemo(() => {
    const agg = (key) => {
      const m = {};
      (rows || []).forEach((r) => { const k = r[key] || "—"; m[k] = (m[k] || 0) + 1; });
      return Object.entries(m).map(([name, value]) => ({ name, value })).sort((a, b) => b.value - a.value).slice(0, 12);
    };
    const stMap = {};
    (rows || []).forEach((r) => { const s = r.verification_status || "Discovered"; stMap[s] = (stMap[s] || 0) + 1; });
    return { byCat: agg("category"), byCity: agg("city"), byStatus: Object.entries(stMap).map(([name, value]) => ({ name, value })) };
  }, [rows]);

  if (rows === null) return <div className="flex h-64 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-teal-500" /></div>;

  const COLORS = ["#0d9488", "#0ea5e9", "#8b5cf6", "#d97706", "#059669", "#f43f5e"];

  return (
    <div>
      <SectionHead title="Reports" desc="Aggregated analytics across all discovered prospects." />
      {rows.length === 0 ? <div className="flex h-48 items-center justify-center rounded-2xl border border-slate-200 bg-white text-sm text-slate-400">No data to report yet.</div> : (
        <div className="grid gap-6 lg:grid-cols-2">
          <Panel title="Prospects by Category"><Chart data={byCat} color="#0d9488" /></Panel>
          <Panel title="Prospects by City"><Chart data={byCity} color="#0ea5e9" /></Panel>
          <Panel title="Pipeline by Status">
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={byStatus} layout="vertical" margin={{ left: 20 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis type="number" tick={{ fontSize: 12 }} /><YAxis type="category" dataKey="name" width={90} tick={{ fontSize: 12 }} />
                <Tooltip /><Bar dataKey="value" radius={[0, 6, 6, 0]}>{byStatus.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}</Bar>
              </BarChart>
            </ResponsiveContainer>
          </Panel>
        </div>
      )}
    </div>
  );
}

function Panel({ title, children }) {
  return <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"><h3 className="mb-4 font-display text-base font-bold text-slate-900">{title}</h3>{children}</div>;
}
function Chart({ data, color }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} layout="vertical" margin={{ left: 20 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis type="number" tick={{ fontSize: 12 }} /><YAxis type="category" dataKey="name" width={120} tick={{ fontSize: 11 }} />
        <Tooltip /><Bar dataKey="value" fill={color} radius={[0, 6, 6, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
